import React, { useEffect, useState } from "react";
import {
    Typography,
    Grid,
    Avatar,
    makeStyles,
    Card,
    Button,
    Paper,
    Box,
} from "@material-ui/core";

import FiberManualRecordRoundedIcon from "@material-ui/icons/FiberManualRecordRounded";
import { Link } from "react-router-dom";
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import EditIcon from '@material-ui/icons/Edit';
import PeopleIcon from '@material-ui/icons/People';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import { logout } from "../../viewmodel/providers/login";

import routes from "../../utils/routes.json";
import { LowerbarState } from "../../model/lowerBarState";

import { getUserInfo } from "../../viewmodel/providers/userInfo";
import { useProfile } from "../../viewmodel/hooks/getProfile";
import { UserContext } from "../../viewmodel/providers/user-context";
import { getUserRating } from "../../viewmodel/providers/rating";

const useStyles = makeStyles(() => ({
    avatar: {
        width: "200px",
        height: "200px",
        marginTop: "5%",
        marginBottom: "1%",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    centerVertical: {
        marginTop: "auto",
        marginBottom: "auto",
    },
    greyText: {
        color: "#484848",
    },
    greyTextforCard: {
        color: "#484848",
        fontFamily: "Copperplate",
    },
    flex1: {
        flexGrow: 1,
    },
    centerText: {
        textAlign: "center",
    },
    card: {
        backgroundColor: "#959EA7",
    },
    box: {
        backgroundColor: "orange",
        width: "50%",
        textAlign: "center",
        marginRight: "auto",
        marginLeft: "auto",
    },
    points: {
        textAlign: "center",
        width: "50%",
        maxWidth: "100%",
        marginLeft: "auto",
        marginRight: "auto",
        fontSize: "23px",
    },
    button: {
        color: "black",
        width: "3.5rem",
        height: "3.5rem",
        textAlign: "left",
        marginInlineStart: "1rem",
        ["@media (max-heigth: 1300px)"]: {
            width: "5rem",
            height: "5rem",
        },
        ["@media (max-heigth: 980px)"]: {
            width: "3.5rem",
            height: "3.5rem",
        },
        ["@media (max-heigth: 750px)"]: {
            width: "2rem",
            height: "2rem",
        },
    },
    buttonColor: {
        color: "#FFA500",
    },
    optionsButton: {
        backgroundColor: "#959EA7",
        "&:hover": {
            background: "#E8E8E8",
        },
        color: "black",
        textTransform: "none",
        height: "100%",
        flex: 0.1,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        ["@media (max-width: 1500px)"]: {
            flex: 0.15,
        },
        ["@media (max-width: 980px)"]: {
            flex: 0.2,
        },
        ["@media (max-width: 750px)"]: {
            flex: 0.3,
        },
        ["@media (max-width: 540px)"]: {
            flex: 0.35,
        },
        ["@media (max-width: 450px)"]: {
            flex: 0.4,
        },
        ["@media (max-width: 400px)"]: {
            flex: 0.5,
        },
        ["@media (max-width: 350px)"]: {
            flex: 0.7,
        },
    },
    lower: {
        flexGrow: 2,
    },
    linkButton: {
        paddingLeft: 0,
        textTransform: "none",
    },
    link: {
        padding: "0 8px",
    },
    paperPlaceHolder: {
        height: "30px",
        marginTop: "6px",
        marginBottom: "6px",
        backgroundColor: "#bdbdbd",
    },
    size1: {
        width: "50%",
        maxWidth: "100%",
        fontSize: "55px",
    },
    size2: {
        width: "40%",
        maxWidth: "100%",
    },
    preferences: {
        width: "80%",
        textAlign: "start",
        marginInlineStart: "1rem",
        maxWidth: "100%",
        fontSize: "25px",
        textColor: "black",
        ["@media (max-heigth: 1217px)"]: {
            fontSize: "40px",
        },
        ["@media (max-heigth: 980px)"]: {
            fontSize: "20px",
        },
        ["@media (max-heigth: 750px)"]: {
            fontSize: "15px",
        },
    },
}));

export default function Profile(): JSX.Element {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, setProfileUser] = useProfile();
    const [rating, setRatingUser] = useState(0);
    const userId: string = React.useContext(UserContext).userId;
    useEffect(() => {
        getUserInfo(userId, setProfileUser);
        getUserRating(setRatingUser);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const userInfoDisplay = state.user?.username ? (
        <Card elevation={0} className={`${classes.card} ${classes.flex1}`}>
            <Avatar
                alt={state.user.name}
                src={state.user.image}
                className={`${classes.centerHorizontal}  ${classes.avatar}`}
            />
            <Typography variant="h3" className={`${classes.centerHorizontal} ${classes.centerText} ${classes.size1}`}>
                {state.user.name}
            </Typography>
            <Typography variant="h5" className={`${classes.centerHorizontal} ${classes.centerText} ${classes.greyTextforCard}`}>
                {state.user.username}
            </Typography>
        </Card>
    ) : (
        <Card elevation={0} className={`${classes.card} ${classes.flex1}`}>
            <Avatar className={`${classes.centerHorizontal}  ${classes.avatar}`}>
                ?
            </Avatar>
            <Paper className={`${classes.paperPlaceHolder} ${classes.centerHorizontal} ${classes.size1}`} elevation={0} />
            <Paper className={`${classes.paperPlaceHolder} ${classes.centerHorizontal} ${classes.size2}`} elevation={0} />
        </Card>
    );

    return (
        <MainScreen lower={true} back={true} backPath={routes.menu} fullWidth={true} lowerBarState={LowerbarState.SETTINGS}>
            <Grid container direction="row" justify="space-evenly">
                {userInfoDisplay}
            </Grid>
            <Box borderRadius={16} className={`${classes.box}`}>
                <Typography className={`${classes.greyText} ${classes.points}`} variant="body1">
                    {Math.ceil(rating)} XP
                </Typography>
            </Box>
            <Grid container spacing={0} className={`${classes.lower}`}>
                <Grid container direction="column" justify="space-evenly">
                    <Link to={routes.settings} className={`${classes.optionsButton} ${classes.link}`}>
                        <Button className={classes.linkButton}>
                            <SettingsApplicationsIcon className={`${classes.button}`} />
                            <Typography className={`${classes.preferences}`} variant="body1">
                                {t("profile.preferences")}
                            </Typography>
                        </Button>
                    </Link>
                    <Link to={routes.editAccout} className={`${classes.optionsButton} ${classes.link}`}>
                        <Button className={classes.linkButton}>
                            <EditIcon className={`${classes.button}`} />
                            <Typography className={`${classes.preferences}`} variant="body1">
                                {t("profile.edit")}
                            </Typography>
                        </Button>
                    </Link>
                    <Link to={routes.friendsList} color="primary" className={`${classes.optionsButton} ${classes.link}`}>
                        <Button className={classes.linkButton}>
                            <PeopleIcon className={`${classes.button}`} />
                            <Typography className={`${classes.preferences}`} variant="body1">
                                {t("profile.friends")}
                            </Typography>
                        </Button>
                    </Link>
                    <Button className={classes.optionsButton} onClick={() => logout()}>
                        <ExitToAppIcon className={`${classes.button}`} />
                        <Typography className={`${classes.preferences}`} variant="body1">
                            {t("profile.logout")}
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </MainScreen>
    );
}
